import { User } from '../../models/authentication/user';
import { UserRole } from '../../enumerations/user-role';

export class AuthUser {
  access_token?: string;
  refresh_token?: string;
  user: User = new User();

  get isValid(): boolean {
    return !!this.access_token && !!this.user.id;
  }

  get isClient(): boolean {
    return this.isValid && this.user.role === UserRole.CLIENT;
  }

  get isAdminSite(): boolean {
    return this.isValid && this.user.role === UserRole.ADMIN_SITE;
  }

  get isSuperAdmin(): boolean {
    return this.isValid && this.user.role === UserRole.SUPERUSER;
  }

  // --- Gestion des accès Utilisateurs ---
  get canAccessUser(): boolean {
    return this.isClient;
  }

  get canSaveUser(): boolean {
    return this.isSuperAdmin;
  }

  // --- Gestion des Sites ---
  get hasSite(): boolean {
    return !!this.user?.site_name;
  }

  get canAccessSite(): boolean {
    return this.isSuperAdmin;
  }

  get canSaveSite(): boolean {
    return this.isSuperAdmin;
  }

  get canManageManySite(): boolean {
    return this.isSuperAdmin;
  }

  // --- Paramétrage technique ---
  get canAccessVehicleTypes(): boolean {
    return this.isSuperAdmin;
  }

  get canAccessTariffs(): boolean {
    return this.isSuperAdmin || this.isAdminSite;
  }

  get canAccessTarifsNonAbonnement(): boolean {
    return this.isSuperAdmin || this.isAdminSite;
  }

  get canSaveTariff(): boolean {
    return this.isAdminSite;
  }

  get canAccessParameters(): boolean {
    return (
      this.canAccessSite || this.canAccessVehicleTypes || this.canAccessTariffs
    );
  }

  // --- Dashboard & Activité ---
  get canAccessDashboard(): boolean {
    return this.isSuperAdmin;
  }

  get canAccessPassage(): boolean {
    return this.isClient;
  }

  get canAccessPayments(): boolean {
    return this.isClient;
  }

  // --- Abonnés & Souscriptions ---
  get canAccessTollSubscribers(): boolean {
    return this.isSuperAdmin || this.isAdminSite;
  }

  get canSaveTollSubscriber(): boolean {
    return this.isAdminSite;
  }

  get canChangeTollSubscriberStatus(): boolean {
    return this.isAdminSite;
  }

  get canAccessSubscriptions(): boolean {
    return this.isSuperAdmin || this.isAdminSite;
  }

  // --- Historique & Logs ---
  get canAccessEventHistory(): boolean {
    return this.isSuperAdmin;
  }

  get canAccessHistorique(): boolean {
    return this.isSuperAdmin;
  }

  // --- SECTION REPORTING (4 Accès Distincts) ---

  /** 1. Accès au Reporting Consolidé (Passages / Recettes / Détails) */
  get canAccessReporting(): boolean {
    return this.isSuperAdmin || this.isAdminSite;
  }

  /** 2. Accès aux Rapports Archives / Logs PDF/Excel */
  get canAccessReports(): boolean {
    return this.isSuperAdmin;
  }

  /** 3. Accès au Rapport Global Statistique */
  get canAccessGlobalReport(): boolean {
    return this.isSuperAdmin;
  }

  /** 4. Accès au Rapport de Session / Vacation */
  get canAccessSessionReport(): boolean {
    return this.isSuperAdmin;
  }

  // --- Caisse & Finances ---
  get canAccessCaisse(): boolean {
    return this.isSuperAdmin;
  }

  get canSaveCaisseOperation(): boolean {
    return this.isSuperAdmin;
  }

  // --- Système & Paramètres avancés ---
  get canAccessSynchronization(): boolean {
    return this.isSuperAdmin;
  }

  get canAccessSettings(): boolean {
    return this.isSuperAdmin;
  }

  get canAccessVacation(): boolean {
    return this.isSuperAdmin;
  }

  // --- Rôles métiers / Accès spécifiques ---
  get canAccessAdmin(): boolean {
    return this.isSuperAdmin || this.isAdminSite;
  }

  get canAccessAgent(): boolean {
    return this.isSuperAdmin;
  }

  get canAccessAme(): boolean {
    return this.isSuperAdmin;
  }

  get canAccessCabine(): boolean {
    return this.isSuperAdmin;
  }

  get canAccessCaissier(): boolean {
    return this.isSuperAdmin;
  }

  get canAccessControle(): boolean {
    return this.isSuperAdmin;
  }

  get canAccessManquant(): boolean {
    return this.isSuperAdmin;
  }

  get canAccessRecette(): boolean {
    return this.isSuperAdmin;
  }

  get canAccessReceveur(): boolean {
    return this.isSuperAdmin;
  }

  get canAccessReddition(): boolean {
    return this.isSuperAdmin;
  }

  get canAccessResponsable(): boolean {
    return this.isSuperAdmin;
  }

  get canAccessSupervision(): boolean {
    return this.isSuperAdmin;
  }

  get canAccessSurveillant(): boolean {
    return this.isSuperAdmin;
  }

  get canAccessProfile(): boolean {
    return this.isValid;
  }
}
